<script setup lang="ts">
import { ZhPanel } from '@zerohuman/ui'
import { RouterLink } from 'vue-router'

/**
 * A single Home HQ stat tile: label, count, and a link to the detail page. Shared by the
 * gates/blockers/runs/spend tiles on `HomeView.vue`, which differ only in these four values
 * (spend also uses the default slot for its "of X day cap" caption). The tile is a kit panel, so its
 * ground, border and padding are the theme's.
 */
defineProps<{
    testid: string
    to: string
    label: string
    value: string | number
}>()
</script>

<template>
	<ZhPanel as="article" :data-testid="testid">
		<RouterLink class="block" :to="to">
			<p class="text-muted-foreground text-xs uppercase">{{ label }}</p>
			<p class="text-2xl font-medium tabular-nums">{{ value }}</p>
			<slot />
		</RouterLink>
	</ZhPanel>
</template>
